import { Arabic } from "flatpickr/dist/l10n/ar"
import arEG from "rsuite/locales/ar_EG"
import enUS from "rsuite/locales/en_US"

/** Portal Arabic language codes (LanguageDropdown / i18n). */
export const isArabicUiLanguage = language => {
  const lang = String(language || "").toLowerCase()
  return lang === "sa" || lang === "ar" || lang.startsWith("ar-")
}

/** Flatpickr locale object for the active UI language. */
export const getFlatpickrLocale = language =>
  isArabicUiLanguage(language) ? Arabic : undefined

/** RSuite base locale for the active UI language. */
export const getRsuiteBaseLocale = language =>
  isArabicUiLanguage(language) ? arEG : enUS
